<template>
    <IonPage>
        <IonContent>
            <div
                v-if="userStore.user"
                class="flex justify-center"
            >
                <IonButton
                    class="mt-4 w-full mx-10 max-w-96"
                    shape="round"
                    @click="userStore.logoutUser"
                >
                    <strong class="text-xl">{{ $t('logout.button') }}</strong>
                </IonButton>
            </div>
            <div class="p-4">
                <h6 class="mb-1">Impressum </h6>
                <p><strong>Firmenwortlaut</strong></p>
                <p>VirtualShepherd </p>
                <p><strong>Unternehmensgegenstand</strong></p>
                <p>Softwareentwicklung</p>
                <p><strong>UID-Nummer</strong></p>
                <p>ATU 1234567</p>
                <p><strong>Firmenbuchnummer und Firmenbuchgericht</strong></p>
                <p>12345v Handelsgericht Wien</p>
                <p><strong>Firmensitz</strong></p>
                <p>Alm</p>
                <p> Niederösterreich | Austria</p>
                <p><strong>Kontaktdaten</strong></p>
                <p>Tel: +43 664 12 34 567</p>
                <p>E-Mail: app@virtualshepherd.at</p>
                <p><strong>Geschäftsführung</strong></p>
                <p>Projektkonsortium</p>
                <img
                    class="mt-4 mb-2"
                    src="/FFG_Logo_DE_RGB_1500px.png"
                />
                <p><em>This project is funded by Österreichische Forschungsförderungsgesellschaft mbH (FFG) within the
                        programme „ASAP Ausschreibung 2022“ (Project No. FO999910946)</em></p>

                <h6>Datenschutz</h6>
                <p><strong>Erklärung der Informationspflicht (Datenschutzerklärung)</strong></p>
                <p>Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher
                    ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen
                    Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im
                    Rahmen unserer Website. Beim Besuch unserer Webseite wird Ihre IP-Adresse, Beginn und Ende der
                    Sitzung für die Dauer dieser Sitzung erfasst. Dies ist technisch bedingt und stellt damit ein
                    berechtigtes Interesse iSv Art 6 Abs 1 lit f DSGVO dar. </p>
                <p class="mt-2"><strong>Kontakt mit uns</strong></p>
                <p>Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre
                    angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate
                    bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. </p>
                <p class="mt-2"><strong>Cookies</strong></p>
                <p>Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit
                    Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Wir nutzen
                    Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät
                    gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch
                    wiederzuerkennen. Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er
                    Sie über das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei der
                    Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein. </p>
                <p class="mt-1">Web-Analyse</p>
                <p>
                    Diese Website nutzt aufgrund unserer berechtigten Interessen zur Optimierung und Analyse unseres
                    Online-Angebots im Sinne des Art. 6 Abs. 1 lit. f. DSGVO den Dienst „Google Analytics“, welcher von
                    der Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) angeboten wird. Der Dienst
                    (Google Analytics) verwendet „Cookies“ – Textdateien, welche auf Ihrem Endgerät gespeichert werden.
                    Die durch die Cookies gesammelten Informationen werden im Regelfall an einen Google-Server in den
                    USA gesandt und dort gespeichert.</p>
                <p class="mt-1">Google LLC hält das europäische Datenschutzrecht ein und ist unter dem Privacy-Shield-Abkommen
                    zertifiziert: https://www.privacyshield.gov/ Auf dieser Website greift die IP-Anonymisierung. Die
                    IP-Adresse der Nutzer wird innerhalb der Mitgliedsstaaten der EU und des Europäischen
                    Wirtschaftsraum und in den anderen Vertragsstaaten des Abkommens gekürzt. Nur in Einzelfällen wird
                    die IP-Adresse zunächst ungekürzt in die USA an einen Server von Google übertragen und dort gekürzt.
                    Durch diese Kürzung entfällt der Personenbezug Ihrer IP-Adresse. Die vom Browser übermittelte
                    IP-Adresse des Nutzers wird nicht mit anderen von Google gespeicherten Daten kombiniert.</p>
                <p class="mt-1">Im Rahmen der Vereinbarung zur Auftragsdatenvereinbarung, welche wir als Websitebetreiber mit der
                    Google Inc. geschlossen haben, erstellt diese mithilfe der gesammelten Informationen eine Auswertung
                    der Websitenutzung und der Websiteaktivität und erbringt mit der Internetnutzung verbundene
                    Dienstleistungen. Die von Google in unserem Auftrag erhobenen Daten werden genutzt, um die Nutzung
                    unseres Online-Angebots durch die einzelnen Nutzer auswerten zu können, z. B. um Reports über die
                    Aktivität auf der Website zu erstellen, um unser Online-Angebot zu verbessern.</p>
            </div>
        </IonContent>
    </IonPage>
</template>

<script
    lang="ts"
    setup
>
import useHeader from '@/composables/useHeader';
import { useUserStore } from '@/store/user';
import { IonButton, IonContent, IonPage } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const userStore = useUserStore();

useHeader({
    title: t("header.profile"),
    showBackButton: true,
    goBackRoute: "/",
    showConfirmButton: false
});

</script>


<style scoped>
ion-button {
    --background-hover: var(--action-button-color, #59c4f6);
    --background: var(--action-button-color, #59c4f6);
    --color: var(--ion-color-light-contrast);
}
</style>